import styled, { keyframes } from 'styled-components';
import { createGradientOrSolid } from '../Helper/utils';

const showLayout = keyframes`
    0% {background-color: rgba($color: #000000, $alpha: 0);}
    100% {background-color: rgba($color: #000000, $alpha: 0.4);}
`;

const hideLayout = keyframes`
    0% {background-color: rgba($color: #000000, $alpha: 0.4);}
    100% {background-color: rgba($color: #000000, $alpha: 0);}
`;

const showModal = keyframes`
    0% {opacity: 0;}
    40% {opacity: 0;}
    100% {opacity: 1;}
`;

const hideModal = keyframes`
    0% {opacity: 1;}
    100% {opacity: 0;}
`;

export const StyledOverlay = styled.div`
    animation: ${showLayout} 1s forwards;
    position: ${(props: any) => (props.preview ? 'absolute' : 'fixed')};
    width: ${(props: any) => (props.preview ? '100%' : '100vw')};
    height: ${(props: any) => (props.preview ? '100%' : '100vh')};
    visibility: ${(props: any) => props.visible ? 'visible' : 'hidden'};
    display: flex;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    z-index: 10;
    background: ${(props: any) =>
        props.showOverlay ? '#00000080' : 'transparent'};
    transition: 0.3s all;

    &.fadeout {
        animation: ${hideLayout} 0.3s forwards;
    }
` as any;

export const StyledModalBorder = styled.div`
    animation: ${showModal} 0.6s forwards;
    opacity: 0;
    max-width: 400px;
    width: 90%;
    padding: 5px;
    border-radius: 30px;
    background: ${(props: any) => createGradientOrSolid(props.colors)};

    &.fadeout {
        animation: ${hideModal} 0.3s forwards;
    }
` as any;

export const StyledModal = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    padding: 20px;
    padding-top: 60px;
    border-radius: 24px;
    background: ${(props: any) => createGradientOrSolid(props.colors)};
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: ${(props: any) => props.fontFamily};

    .closeButton {
        position: absolute;
        cursor: pointer;
        top: 20px;
        right: 15px;
        height: 32px;
    }

    h2 {
        margin: 0;
        margin-bottom: 16px;
        font-size: ${(props: any) => `${props.headerFontSize}px`};
        background: ${(props: any) =>
            createGradientOrSolid(props.headerColors)};
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    h5 {
        margin-top: 0;
        margin-bottom: 20px;
        text-align: center;
    }

    button {
        height: 60px;
        width: 100%;
        cursor: pointer;
    }
` as any;
